var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.5L7.0665 4.5C8.94655 4.49995 10.7551 4.4999 12.0917 4.89557C12.7808 5.09957 13.3939 5.42141 13.8328 5.94412C14.2779 6.47425 14.5 7.15857 14.5 8C14.5 8.84144 14.2779 9.52576 13.8328 10.0559C13.3939 10.5786 12.7808 10.9004 12.0917 11.1044C10.9782 11.4341 9.53709 11.4891 8 11.4982V16H7V4.5ZM8 5.50225C9.5289 5.51219 10.833 5.56585 11.8078 5.85444C12.3855 6.02544 12.7974 6.2661 13.067 6.58714C13.3303 6.90076 13.5 7.34144 13.5 8C13.5 8.65857 13.3303 9.09925 13.067 9.41287C12.7974 9.73391 12.3855 9.97457 11.8078 10.1456C10.833 10.4342 9.5289 10.4878 8 10.4978V5.50225Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.59306f1e76b2b44e9a18e67e83c30c70.svg";
export { ForwardRef as ReactComponent };